import { render, staticRenderFns } from "./FilaTarefas.vue?vue&type=template&id=59e1d370"
import script from "./FilaTarefas.vue?vue&type=script&lang=js"
export * from "./FilaTarefas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports